<template>
  <!-- Labelled divider: a hairline with centered text ("OR" on auth screens) -->
  <div v-if="label || $slots.default" class="divider divider--labelled" role="separator" :aria-label="label">
    <span class="divider-label"><slot>{{ label }}</slot></span>
  </div>
  <hr v-else class="divider" />
</template>

<script setup lang="ts">
/**
 * Horizontal separator (wraps the global .divider vocabulary). Plain by
 * default; pass `label` (or default slot) for the centered "OR" separator the
 * auth/upgrade screens hand-rolled from an absolute hairline + caps label.
 */
defineProps<{
  /** Centered label text — renders the labelled "OR"-style divider. */
  label?: string
}>()
</script>
